module.exports = __webpack_public_path__ + "static/slide2-2f49a67389ffba0f22dc18066d4fc45a.png";